import { render, staticRenderFns } from "./TableNoCard.vue?vue&type=template&id=82c68e16"
import script from "./TableNoCard.vue?vue&type=script&lang=js"
export * from "./TableNoCard.vue?vue&type=script&lang=js"
import style0 from "./TableNoCard.vue?vue&type=style&index=0&id=82c68e16&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports